export default {
  crashCourseList: state => state.crashCourseList,
  crashCourseSubjectList: state => state.crashCourseSubjectList
}
